



















































































import Vue from "vue";
import ObjectParser from "~/helper/ObjectParser";
import TrialCenter from "../../../shared/TrialCenter";

const NEW_TRIAL = {
  name: '',
  anonymizationConfig: null,
  centers: [],
  trialCenters: [] as TrialCenter[],
  AETitle: '',
  port: '',
  ip: '',
}
export default Vue.extend({
  props: ['fetchClinicalTrials'],
  data: () => ({
    title: 'Create a new clinical trial',
    clinicalTrial: {...NEW_TRIAL},
    name: '',
    anonymizationConfigs: [],
    selectedConfig: null,
    availableCenters: []
  }),
  created() {
    this.loadCenters();
  },
  methods: {
    async loadCenters() {
      try {
        let res = await this.$axios.get(`/center`);
        this.availableCenters = res.data;
      } catch (e) {
        this.$toast.error(`Failed to load centers: ${e.response.data.message}.`);
      }
    },
    handleAddCenter(centers: any) {
      const newTrialCenters: TrialCenter[] = [];
      const remainingCenterIds: number[] = centers.map((center: { id: number }) => center.id);
      let i = remainingCenterIds.length;

      // Get existing values
      while (i--) {
        let id = remainingCenterIds[i]
        this.clinicalTrial.trialCenters.forEach(trialCenter => {
          if (trialCenter.centerId == id) {
            newTrialCenters.push(trialCenter);
            remainingCenterIds.splice(i, 1);
          }
        });
      }
      newTrialCenters.reverse(); // Maintain the order since we insert in reverse

      // Add remaining
      remainingCenterIds.forEach(id => newTrialCenters.push({
        centerId: id,
        trialCenterId: '',
      }));

      this.clinicalTrial.trialCenters = newTrialCenters;
    },
    handleDialogChange(dialogVal: boolean) {
      // Reload data everytime dialog is opened
      if (dialogVal) {
        this.loadAnonymizationConfigs();
      }
    },
    async loadAnonymizationConfigs() {
      let res = await this.$axios.get(`anonymization-config/`);
      this.anonymizationConfigs = res.data;
    },
    hasEmptyFields() {
      const hasEmptyClinicalTrialFields = ObjectParser.hasEmptyFields(this.clinicalTrial)
      const emptyTrialCenters = this.clinicalTrial.trialCenters.filter(trialCenter => trialCenter.trialCenterId === '');
      // Also check centers length as it passes above test because vue transforms the list into an observer
      return hasEmptyClinicalTrialFields || emptyTrialCenters.length > 0 || this.clinicalTrial.centers.length == 0;
    },
    async handleAdd() {
      try {
        await this.$axios.post(`clinical-trial/`, this.clinicalTrial)
        this.fetchClinicalTrials();
        this.clinicalTrial = {...NEW_TRIAL};
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
    }
  }
})
